function makeErrorNotification (component: Vue, message: string) {
  component.$eventBus.$emit('notify', {
    color: 'var(--status-error-color)',
    message: message,
    header: 'Error',
    icon: 'warning'
  })
}

function makeSuccessNotification (component: Vue, message: string) {
  component.$eventBus.$emit('notify', {
    color: 'var(--status-success-color)',
    message: message,
    header: 'Success',
    icon: 'Success'
  })
}

export { makeErrorNotification, makeSuccessNotification }
